if (!customElements.get('td-review-block')) {
  class TdReview extends HTMLElement {
    constructor() {
      super();

      this.SELECTORS = {
        scrollTrigger: '[data-td-scroll-to-reviews="true"]',
        reviewsTarget: '#judgeme_product_reviews',
        header: 'header-component, header, .section-header'
      };

      this.handleScrollTrigger = this.handleScrollTrigger.bind(this);
    }

    connectedCallback() {
      this.scrollTrigger = this.querySelector(this.SELECTORS.scrollTrigger);

      if (!this.scrollTrigger) return;

      this.scrollTrigger.addEventListener('click', this.handleScrollTrigger);
      this.scrollTrigger.addEventListener('keydown', this.handleScrollTrigger);
    }

    disconnectedCallback() {
      if (!this.scrollTrigger) return;

      this.scrollTrigger.removeEventListener('click', this.handleScrollTrigger);
      this.scrollTrigger.removeEventListener('keydown', this.handleScrollTrigger);
    }

    handleScrollTrigger(event) {
      if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;

      event.preventDefault();

      const target = document.querySelector(this.SELECTORS.reviewsTarget);
      if (!target) return;

      const header = document.querySelector(this.SELECTORS.header);
      const offset = header?.offsetHeight || 0;
      const topPosition = target.getBoundingClientRect().top + window.scrollY - offset;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.scrollTo({
        top: topPosition,
        behavior: reduceMotion ? 'instant' : 'smooth'
      });

      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }
  }

  customElements.define('td-review-block', TdReview);
}
